import { StyledSuggestedSimpleChipItem } from "./styles";

export type SuggestedChipItemProps = {
    id: string;
    text: string;
    onCloseItem(): void;
};

export const SuggestedChipItem = ({ text, onCloseItem }: SuggestedChipItemProps) => {
    return (
        <StyledSuggestedSimpleChipItem
            text={text}
            customIcon="plus-circle-filled"
            hideActionButton={true}
            isCompact
            onClick={onCloseItem}
            maxAmountOfCharacters={30}
        />
    );
};
